import React, { useEffect } from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import Layout from '../../components/common/Layout/Layout';

const DisclosurePage = () => {
    // Force page to start from top when component mounts
    useEffect(() => {
        // Scroll to top immediately (no smooth animation)
        window.scrollTo(0, 0);
        
        // Also set scroll restoration to manual to prevent browser from remembering position
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    }, []);

    const styles = {
        pageContainer: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ffffff'
        },
        
        mainContent: {
            flex: 1,
            backgroundColor: '#ffffff',
            padding: '3rem 0'
        },

        container: {
            maxWidth: '1000px',
            margin: '0 auto',
            padding: '0 2rem',
            lineHeight: '1.6'
        },

        pageTitle: {
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#1a202c',
            marginBottom: '3rem',
            textAlign: 'center',
            borderBottom: '3px solid #22c55e',
            paddingBottom: '1rem'
        },

        sectionTitle: {
            fontSize: '1.3rem',
            fontWeight: '700',
            color: '#1a202c',
            marginTop: '2.5rem',
            marginBottom: '1rem'
        },

        firstSectionTitle: {
            fontSize: '1.3rem',
            fontWeight: '700',
            color: '#1a202c',
            marginTop: '0',
            marginBottom: '1rem'
        },

        paragraph: {
            fontSize: '1rem',
            color: '#4a5568',
            lineHeight: '1.7',
            marginBottom: '1.5rem',
            textAlign: 'justify'
        },

        tableContainer: {
            marginBottom: '2rem',
            overflowX: 'auto'
        },

        table: {
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #d1d5db',
            marginBottom: '1.5rem',
            backgroundColor: '#ffffff'
        },

        headerRow: {
            backgroundColor: '#f8f9fa'
        },

        headerCell: {
            border: '1px solid #d1d5db',
            padding: '12px 16px',
            textAlign: 'left',
            fontWeight: '700',
            color: '#1a202c',
            fontSize: '1rem'
        },

        tableRow: {
            borderBottom: '1px solid #d1d5db'
        },

        tableCell: {
            border: '1px solid #d1d5db',
            padding: '12px 16px',
            color: '#4a5568',
            fontSize: '1rem',
            lineHeight: '1.5'
        },

        content: {
            fontSize: '1rem',
            color: '#2d3748',
            lineHeight: '1.7'
        }
    };

    return (
        <>
            <style>{`
                @media (max-width: 768px) {
                    .container {
                        padding: 0 1rem !important;
                    }
                    
                    .page-title {
                        font-size: 2rem !important;
                        margin-bottom: 2rem !important;
                    }
                    
                    .section-title, .first-section-title {
                        font-size: 1.1rem !important;
                        margin-top: 2rem !important;
                    }
                    
                    .main-content {
                        padding: 2rem 0 !important;
                    }
                    
                    .table-container {
                        font-size: 0.9rem !important;
                    }
                    
                    .table th, .table td {
                        padding: 8px 12px !important;
                        font-size: 0.9rem !important;
                    }
                }

                @media (max-width: 640px) {
                    .page-title {
                        font-size: 1.8rem !important;
                    }
                    
                    .section-title, .first-section-title {
                        font-size: 1rem !important;
                    }
                    
                    .paragraph {
                        font-size: 0.95rem !important;
                    }
                    
                    .table th, .table td {
                        padding: 6px 8px !important;
                        font-size: 0.85rem !important;
                    }
                }
            `}</style>

            <div style={styles.pageContainer}>
                {/* Header */}
                <Header />

                {/* Main Content */}
                <main style={styles.mainContent} className="main-content">
                    <div style={styles.container} className="container">
                        <h1 style={styles.pageTitle} className="page-title">
                            Commission Structure & Disclosure
                        </h1>

                        <div style={styles.content}>
                            <div style={styles.tableContainer} className="table-container">
                                <table style={styles.table} className="table">
                                    <thead>
                                        <tr style={styles.headerRow}>
                                            <th style={styles.headerCell}>Scheme Type</th>
                                            <th style={styles.headerCell}>Trail-1st Year onwards</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Liquid/Ultra Short Term Schemes</td>
                                            <td style={styles.tableCell}>0.05% – 0.70%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Short Term Income Funds</td>
                                            <td style={styles.tableCell}>0.50% – 0.90%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Income Funds</td>
                                            <td style={styles.tableCell}>0.40% – 1.00%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Gilt Funds</td>
                                            <td style={styles.tableCell}>0.15% – 0.90%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Hybrid Debt/Monthly Income Plans</td>
                                            <td style={styles.tableCell}>0.90% – 1.20%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Arbitrage Funds</td>
                                            <td style={styles.tableCell}>0.55% – 0.70%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Fund of Funds</td>
                                            <td style={styles.tableCell}>0.25% – 0.50%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>ELSS</td>
                                            <td style={styles.tableCell}>0.65% – 2.00%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Index Funds</td>
                                            <td style={styles.tableCell}>0.30% – 1.00%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Equity/ Hybrid Equity/ Balance Funds</td>
                                            <td style={styles.tableCell}>0.65% – 2.00%</td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}>Fixed Maturity Plans</td>
                                            <td style={styles.tableCell}>Variable</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p style={styles.paragraph}>
                                Details of Scheme level commission on Mutual funds are available with the Relationship Managers and would be produced on demand.
                            </p>

                            <p style={styles.paragraph}>
                                This is on a best effort basis and rates are updated as and when actual rates are received from AMCs.
                            </p>

                            <p style={styles.paragraph}>
                                We are a NISM certified / AMFI registered mutual fund distributor and not an RIA. We get compensated / incentivised by AMCs. We don't charge any fees for our services.
                            </p>
                        </div>
                    </div>
                </main>

                {/* Layout */}
                <Layout />

                {/* Footer */}
                <Footer />
            </div>
        </>
    );
};

export default DisclosurePage;